__turbopack_context__.v({
  "container_headerWithLogo": "HeaderWithLogoLayout-module__mbpQVq__container_headerWithLogo",
});
